export default __webpack_public_path__ + "static/media/ep_06.3998b1b9.png";